import { ICurrentInsurance, IVehicle, IDriver, IContactInfo, IPaymentChoice, IRealTimeAutoResult, ICoverageConfig, IViolationList, IAgenciesContactInfo, IDiscountOption } from "../classes/Domain";
import { IExternalQuote } from "../classes/ExternalQuote";

export interface ICarrierCustomization {
    name: string,
    logoUrl: string
}

export interface IAppState{
    appOfflineData: IOffline | null,
    carrierCustomization: ICarrierCustomization | null,
    zipCode: string,
    stateCode: string,
    coverageConfig: ICoverageConfig | null,
    quoteId: number,
    quoteUid: string,
    currentStep: string,
    currentPath: string,
    vehicles : Array<IVehicle>,
    drivers: Array<IDriver>,
    currentInsurance: ICurrentInsurance | null,
    contactInfo: IContactInfo | null,
    rate: IRealTimeAutoResult | null,
    rateError: string | null,
    paymentChoice: IPaymentChoice | null,
    agenciesContactInfo: IAgenciesContactInfo | null,
    externalQuote: IExternalQuote | null,
    violationList: IViolationList | null,
    discountOption: IDiscountOption | null,
}

export interface IOffline {
    id: number,
    isActive: boolean,
    startOffline: Date,
    endOffline: Date | null,
    message: string
}

export const appInitialState = {
    carrierCustomization : null,
    zipCode: "",
    stateCode: "",
    coverageConfig: null,
    quoteId: 0,
    quoteUid: "",
    coverageConfigCode: "",
    currentStep: "",
    currentPath: "",
    vehicles: [],
    drivers: [],
    currentInsurance: null,
    contactInfo: null,
    rate: null,
    paymentChoice: null,
    externalQuote: null
}